import React from "react";
import {AdServerCard} from "./AdServerCard";
import {IAdServer, ITagMetrics} from "@leap4/entities-discrepancy-common";
import {compact} from "lodash";
import {Grid, Typography, Skeleton} from "@leap4/frontend";

export interface IAdServerCardsProps {
    adServers: Array<{
        adServer: IAdServer & { _id: string },
        totals: ITagMetrics,
        compareData
    }>,
    isLoading: boolean
}

export const AdServerCards = ({adServers, isLoading}: IAdServerCardsProps): JSX.Element => {
    return (
        <>
            <Grid container justifyContent={"center"} direction={"column"} width={"100%"} margin={"0 auto"}>

                <Grid item>
                    <Typography variant={"h5"} pt={5}>Ad-Servers</Typography>
                </Grid>

            </Grid>
            <Grid container justifyContent={"flex-end"} alignItems={'space-between'}  width={"80%"} margin={"0 auto"} flexWrap={'wrap'} >
                {
                    !isLoading ? adServers?.map(adServer => {
                        return (
                                <AdServerCard key={adServer.adServer._id} adServer={adServer.adServer} totals={adServer.totals} compareData={adServer.compareData}/>
                        )
                    }) : [1, 2].map(s => <Skeleton  key={s} sx={{borderRadius: "16px", m:"10px"}} variant={"rounded"}
                                                   height={"300px"} width={"450px"} animation={"wave"}/>)
                }
            </Grid>
        </>
    )


}